<template>
    <rkm-layout-body title="Lista de subgrupos">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-subgrupo-create' })"
                color="primary"
                authorize="store-cadastro-subgrupo"
            >
                Cadastrar subgrupo
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/subgrupo/List'

export default {
    components: { List },
}
</script>